import { ActorSystem, AnyActorRef, AnyEventObject, ErrorActorEvent, sendTo } from 'xstate';
import type { OnShowAlert } from './alerts/events';
import { OnSendDeleteConfirmation } from './events';
import { sendAxiosErrorAlert, sendDeleteConfirmation, sendSuccessAlert } from './utils';
import { ALERT_VIEW_STATE, AppActorSystem, CONFIRMATION_VIEW_STATE } from './xstateSystem';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showAxiosErrorAction: any = sendTo(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ system }: { system: ActorSystem<any> }) => system?.get(ALERT_VIEW_STATE),
  ({ event }: { event: ErrorActorEvent<unknown> }) => sendAxiosErrorAlert(event)
);

export const sendCustomError = ({
  system,
  text = 'An error occurred',
  subText = 'Please try again later.',
}: {
  system: AppActorSystem;
  text: string;
  subText: string;
}) => {
  const errorEvent: OnShowAlert = {
    type: 'ON_SHOW_ALERT',
    payload: {
      text,
      subText,
      type: 'error',
      timeout: 5000,
    },
  };
  system.get(ALERT_VIEW_STATE).send(errorEvent);
};

export const sendCustomSuccessAlert = ({
  system,
  text = 'Success',
  subText = 'Action was successful',
}: {
  system: AppActorSystem;
  text: string;
  subText: string;
}) => {
  system.get(ALERT_VIEW_STATE)?.send(
    sendSuccessAlert({
      text: text,
      subText: subText,
    })
  );
};

export const openDeleteConfirmation = ({
  event,
  self,
  system,
}: {
  event: AnyEventObject;
  self: AnyActorRef;
  system: AppActorSystem;
}) => {
  const deleteEvent = event as OnSendDeleteConfirmation;
  const onConfirm = (id: number) => {
    self.send({ type: 'ON_DELETE', payload: { id } });
  };
  const confirmationEvent = sendDeleteConfirmation(() => onConfirm(deleteEvent.payload.id));
  system.get(CONFIRMATION_VIEW_STATE).send(confirmationEvent);
};
